module.exports = __webpack_public_path__ + "media/images/hero/glyph-c1-0a1275ba385d416c3fc809be2976bde6.svg";